import axios from 'axios'
import qs from 'qs'

const VOUCHER_SELECTOR = '.js-apply-voucher'
const VOUCHER_VALUE_SELECTOR = '.js-apply-voucher-value'
const VOUCHER_BUTTON_SELECTOR = '.js-apply-voucher-button'
const VOUCHER_ERROR_SELECTOR = '.js-apply-voucher-error'
const INVALID_CLASS = 'invalid'

function addApplyVoucherListener(element) {
  const inputEl = element.querySelector(VOUCHER_VALUE_SELECTOR)
  const buttonEl = element.querySelector(VOUCHER_BUTTON_SELECTOR)
  const errorEl = element.querySelector(VOUCHER_ERROR_SELECTOR)

  buttonEl.addEventListener('click', async () => {
    element.classList.remove(INVALID_CLASS)
    const response = await axios({
      method: 'post',
      headers: {'content-type': 'application/x-www-form-urlencoded'},
      url: '/index.php?route=extension/total/voucher/voucher',
      data: qs.stringify({
        voucher: inputEl.value
      }),
    })
    if (!response) return
    const data = response.data
    if (data.success) {
      window.location.reload()
    } else if (data.error) {
      element.classList.add(INVALID_CLASS)
      errorEl.innerHTML = data.error
    }
  })
}

export function initApplyVouchers() {
  const voucherElements = document.querySelectorAll(VOUCHER_SELECTOR)
  voucherElements.forEach(addApplyVoucherListener)
}
